import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex mx-lg-n4 py-2" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "col-12 offset-lg-1 col-lg-10 row g-0" }
const _hoisted_4 = { class: "form-group col-12 col-lg-5 pe-lg-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-first-name" }, [
  /*#__PURE__*/_createTextVNode(" First Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_8 = { class: "form-group col-4 col-lg-2 pe-lg-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "referral-middle-initial" }, " Middle Initial ", -1 /* HOISTED */)
const _hoisted_10 = { class: "form-group col-12 col-lg-5 pe-lg-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-last-name" }, [
  /*#__PURE__*/_createTextVNode(" Last Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_15 = { class: "form-group col-12 col-lg-5 pe-lg-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-relationship" }, [
  /*#__PURE__*/_createTextVNode(" Relation to Referral "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Relationship", -1 /* HOISTED */)
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_22 = { class: "col-12 form-group d-flex" }
const _hoisted_23 = { class: "me-2 mt-2" }
const _hoisted_24 = { class: "col-12 offset-lg-1 col-lg-10 row g-0" }
const _hoisted_25 = { class: "col-12 offset-lg-1 col-lg-10 row g-0" }
const _hoisted_26 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-primary-number" }, [
  /*#__PURE__*/_createTextVNode(" Primary Phone "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_28 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-alternate-number" }, " Fax Number ", -1 /* HOISTED */)
const _hoisted_30 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-email" }, " E-mail Address ", -1 /* HOISTED */)
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 1,
  class: "p-5 w-100 d-flex flex-column text-center text-primary"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-save fa-7x me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1 big-text" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Save Contact In Progress...")
], -1 /* HOISTED */)
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReferralAddressForm = _resolveComponent("ReferralAddressForm")!
  const _component_PhoneNumber = _resolveComponent("PhoneNumber")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_number_only = _resolveDirective("number-only")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    "application-id": Number(_ctx.referral.application)
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("section", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _withDirectives(_createElementVNode("input", {
                    name: "auth-contact-first-name",
                    class: _normalizeClass(["form-control", `${!_ctx.v$.contact.firstName.$error ? '' : 'field-invalid'}`]),
                    maxlength: "50",
                    type: "text",
                    placeholder: "Enter First Name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contact.firstName) = $event)),
                    disabled: !_ctx.isEditable,
                    onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.contact.firstName.$touch && _ctx.v$.contact.firstName.$touch(...args)))
                  }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_6), [
                    [_vModelText, _ctx.contact.firstName]
                  ]),
                  (_ctx.v$.contact.firstName.$error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "First name is required."))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("input", {
                    name: "referral-middle-initial",
                    class: "form-control",
                    maxlength: "1",
                    type: "text",
                    placeholder: "Enter M.I.",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contact.mi) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.contact.mi]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    name: "auth-contact-last-name",
                    class: _normalizeClass(["form-control", `${!_ctx.v$.contact.lastName.$error ? '' : 'field-invalid'}`]),
                    maxlength: "50",
                    type: "text",
                    placeholder: "Enter Last Name",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contact.lastName) = $event)),
                    disabled: !_ctx.isEditable,
                    onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.contact.lastName.$touch && _ctx.v$.contact.lastName.$touch(...args)))
                  }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_12), [
                    [_vModelText, _ctx.contact.lastName]
                  ]),
                  (_ctx.v$.contact.lastName.$error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Last name is required."))
                    : _createCommentVNode("v-if", true)
                ]),
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createCommentVNode(" validate "),
                  _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass(["form-select", `${!_ctx.v$.contact.relationship.$error ? '' : 'field-invalid'}`]),
                    name: "relationship",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.contact.relationship) = $event)),
                    disabled: !_ctx.isEditable,
                    onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.v$.contact.relationship.$touch && _ctx.v$.contact.relationship.$touch(...args)))
                  }, [
                    _hoisted_18,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.RelationToReferral), ([key, value]) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: key,
                        value: value.value
                      }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_19))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_17), [
                    [_vModelSelect, _ctx.contact.relationship]
                  ]),
                  (_ctx.v$.contact.relationship.$error)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Relationship is required."))
                    : _createCommentVNode("v-if", true)
                ]),
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("button", {
                      class: "btn btn-xs btn-primary mb-2",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setAddressToPrimaryAddress()))
                    }, " Use Referral's Address ")
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_24, [
                _createVNode(_component_ReferralAddressForm, {
                  address: _ctx.contact.address,
                  "onUpdate:address": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.contact.address) = $event)),
                  application: _ctx.referral.application,
                  "account-id": _ctx.referral.accountId,
                  "is-primary-address": true,
                  onUpdateAddressDetails: _ctx.updateAddressDetails,
                  onUpdateAddressCountry: _ctx.updateAddressCountry,
                  onUpdateAddressState: _ctx.updateAddressState,
                  ref: "address"
                }, null, 8 /* PROPS */, ["address", "application", "account-id", "onUpdateAddressDetails", "onUpdateAddressCountry", "onUpdateAddressState"])
              ]),
              _createElementVNode("section", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _withDirectives(_createVNode(_component_PhoneNumber, {
                    "enable-country": true,
                    "phone-type-options": _ctx.phoneNumberOptions,
                    value: _ctx.contact.phoneNumbers[_ctx.primaryNumberIndex(_ctx.contact.phoneNumbers)].number,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.contact.phoneNumbers[_ctx.primaryNumberIndex(_ctx.contact.phoneNumbers)].number) = $event)),
                    extension: 
                                    _ctx.contact.phoneNumbers[_ctx.primaryNumberIndex(_ctx.contact.phoneNumbers)].extension
                                ,
                    "onUpdate:extension": _cache[10] || (_cache[10] = ($event: any) => ((
                                    _ctx.contact.phoneNumbers[_ctx.primaryNumberIndex(_ctx.contact.phoneNumbers)].extension
                                ) = $event)),
                    type: _ctx.contact.phoneNumbers[_ctx.primaryNumberIndex(_ctx.contact.phoneNumbers)].type,
                    "onUpdate:type": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.contact.phoneNumbers[_ctx.primaryNumberIndex(_ctx.contact.phoneNumbers)].type) = $event)),
                    country: _ctx.contact.phoneNumbers[_ctx.primaryNumberIndex(_ctx.contact.phoneNumbers)].country,
                    "onUpdate:country": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.contact.phoneNumbers[_ctx.primaryNumberIndex(_ctx.contact.phoneNumbers)].country) = $event)),
                    disabled: !_ctx.isEditable
                  }, null, 8 /* PROPS */, ["phone-type-options", "value", "extension", "type", "country", "disabled"]), [
                    [_directive_number_only]
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _withDirectives(_createVNode(_component_PhoneNumber, {
                    "enable-country": true,
                    "phone-type-options": _ctx.phoneNumberOptions,
                    value: 
                                    _ctx.contact.phoneNumbers[_ctx.alternativeNumberIndex(_ctx.contact.phoneNumbers)].number
                                ,
                    "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((
                                    _ctx.contact.phoneNumbers[_ctx.alternativeNumberIndex(_ctx.contact.phoneNumbers)].number
                                ) = $event)),
                    extension: 
                                    _ctx.contact.phoneNumbers[_ctx.alternativeNumberIndex(_ctx.contact.phoneNumbers)].extension
                                ,
                    "onUpdate:extension": _cache[14] || (_cache[14] = ($event: any) => ((
                                    _ctx.contact.phoneNumbers[_ctx.alternativeNumberIndex(_ctx.contact.phoneNumbers)].extension
                                ) = $event)),
                    type: _ctx.contact.phoneNumbers[_ctx.alternativeNumberIndex(_ctx.contact.phoneNumbers)].type,
                    "onUpdate:type": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.contact.phoneNumbers[_ctx.alternativeNumberIndex(_ctx.contact.phoneNumbers)].type) = $event)),
                    country: 
                                    _ctx.contact.phoneNumbers[_ctx.alternativeNumberIndex(_ctx.contact.phoneNumbers)].country
                                ,
                    "onUpdate:country": _cache[16] || (_cache[16] = ($event: any) => ((
                                    _ctx.contact.phoneNumbers[_ctx.alternativeNumberIndex(_ctx.contact.phoneNumbers)].country
                                ) = $event)),
                    disabled: !_ctx.isEditable
                  }, null, 8 /* PROPS */, ["phone-type-options", "value", "extension", "type", "country", "disabled"]), [
                    [_directive_number_only]
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _withDirectives(_createElementVNode("input", {
                    name: "auth-contact-email",
                    class: "form-control",
                    maxlength: "50",
                    type: "text",
                    placeholder: "Enter Email",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.contact.email) = $event)),
                    disabled: !_ctx.isEditable
                  }, null, 8 /* PROPS */, _hoisted_32), [
                    [_vModelText, _ctx.contact.email]
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_36))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}